import { types } from "./types";

const initialState = {
  // forms: [],
  // obligations: [],
  // obligationsCounters: {},
  navigateId: 0,
  selectedObligation: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CREATE_OBLIGATION.SUCCESS:
      return {
        ...state,
        obligations: [action.payload, ...state.obligations]
      };
    case types.SET_OBLIGATIONS.SUCCESS:
      return {
        ...state,
        forms: action.payload,
        obligations: action.payload,
      };
    case types.SET_MESSAGES.SUCCESS:
      return {
        ...state,
        messages: action.payload,
      };
    case types.ADD_MESSAGE.SUCCESS:
      return {
        ...state,
        messages: [action.payload, ...state.messages],
      }
    case types.SET_OBLIGATIONS_COUNTERS.SUCCESS:
      return {
        ...state,
        obligationsCounters: {...action.payload}
    }
    case types.CHECK_OBLIGATION.SUCCESS:
      return {
        ...state,
        status: action.payload,
      };
    case types.UPDATE_OBLIGATION_MOTHER.SUCCESS:
        return state;
    case types.UPDATE_OBLIGATION.SUCCESS:
        return state;
    case 'UPDATE_OBLIGATION_FORMS':
        const updatedForms = [...state.forms];
        const updatedForm = {...updatedForms[action.payload.index]};
        updatedForm[action.payload.key] = action.payload.value;
        updatedForms[action.payload.index] = updatedForm;
        return {
            ...state,
            forms: updatedForms
        };
    case 'SET_NAVIGATE_ID':
      return {
        ...state,
        navigateId: action.payload.value
      }
    case 'CLEAR_NAVIGATE_ID':
      return {
        ...state,
        navigateId: 0
      }
      case 'SET_SELECTED_OBLIGATION':
        return {
            ...state,
            selectedObligation: action.payload.value._id
        }
    case 'CLEAR_SELECTED_OBLIGATION':
      return {
        ...state,
        selectedObligation: 0
      }
    case types.DELETE_OBLIGATION.SUCCESS:
      return {
        ...state,
        obligations: state.obligations?.filter(o => o._id !== action.payload)
      };
    case types.MASS_ASSIGN_OBLIGATIONS.SUCCESS:
      return state;
    case types.RESET_OBLIGATIONS.SUCCESS:
      return {
        ...state,
        obligations: []
      };
    default:
      return state;
  }
}

export default reducer;
